import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { SalesRep } from "../models/sales-rep.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";

const BASE_URL = `${BACKEND_URI}/api/sales-rep`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const SET_ENABLED_URL = (id) => `${BASE_URL}/${id}/enable-update`;
const SET_FIVE_DOLLAR_ENABLED_URL = (id) => `${BASE_URL}/${id}/fiveDollarEnable-update`;
const SET_TEN_DOLLAR_ENABLED_URL = (id) => `${BASE_URL}/${id}/tenDollarEnable-update`;
const SET_TEXT_ENABLED_URL = (id) => `${BASE_URL}/${id}/enableText-update`;
const UPDATE_LAST_INVOICE_STATUS = (id) => `${BASE_URL}/${id}/updateStatus`
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;

@Injectable({providedIn: 'root'})
export class SalesRepService {
  hasBeenInvoiced(salesRep: SalesRep) {
    throw new Error('Method not implemented.');
  }
    constructor(private http: HttpClient, private loginService: LoginService){}
    async getAll(): Promise<SalesRep[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<SalesRep[]>(GET_ALL_URL)
            );
        }
    }
    async create(data: SalesRep): Promise<SalesRep> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<SalesRep>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: SalesRep): Promise<SalesRep> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<SalesRep>(UPDATE_URL(id), data)
            );
        }
    }

    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            }catch(err) {}
            } 
        }
        async setEnabled(id: string, enabled: boolean): Promise<SalesRep> {
            if(this.loginService.isloggedIn) {
                console.trace(`setEnabled(${enabled}): user is logged in`)
                return await firstValueFrom(
                    this.http.patch<SalesRep>(SET_ENABLED_URL(id), {enabled})
                );
            }else {
                console.error(`setEnabled(${enabled}): not logged in`)
            }
        }

        async setTenDollarEnabled(id: string, enabled: boolean): Promise<SalesRep> {
            if(this.loginService.isloggedIn) {
                console.trace(`setEnabled(${enabled}): user is logged in`)
                return await firstValueFrom(
                    this.http.patch<SalesRep>(SET_TEN_DOLLAR_ENABLED_URL(id), {enabled})
                );
            }else {
                console.error(`tenDollarEnabled(${enabled}): not logged in`)
            }
        }

        async setFiveDollarEnabled(id: string, enabled: boolean): Promise<SalesRep> {
            if(this.loginService.isloggedIn) {
                console.trace(`setEnabled(${enabled}): user is logged in`)
                return await firstValueFrom(
                    this.http.patch<SalesRep>(SET_FIVE_DOLLAR_ENABLED_URL(id), {enabled})
                );
            }else {
                console.error(`fiveDollarEnabled(${enabled}): not logged in`)
            }
        }

        async setTextEnabled(id: string, enabled: boolean): Promise<SalesRep> {
            if(this.loginService.isloggedIn) {
                console.trace(`setTextEnabled(${enabled}): user is logged in`)
                return await firstValueFrom(
                    this.http.patch<SalesRep>(SET_TEXT_ENABLED_URL(id), {enabled})
                );
            }else {
                console.error(`setTextEnabled(${enabled}): not logged in`)
            }
        }

        async updateLastInvoiceStatus(salesRep: SalesRep, status: string): Promise<SalesRep> {
            if(this.loginService.isloggedIn) {
                return await firstValueFrom(
                    this.http.put<SalesRep>(UPDATE_LAST_INVOICE_STATUS(salesRep.id), null, {
                        params: { status },
                        responseType: 'text' as 'json'
                    })
                );
            } else {
                console.error(`updateLastInvoiceStatus(${status}): not logged in`)
            }
          }
    
        
}
